import * as reducers from "../../reducers/productosCargaMasiva";

export interface ProductosCargaMasivaStore {
  searching: boolean;
  saving: boolean;
  validationResult: any;
  processingResult: any;
}

export const productosCargaMasivaStore: (
  state
) => ProductosCargaMasivaStore = state => {
  const productosCargaMasivaState = state.productosCargaMasivaReducer || {};

  return {
    searching: productosCargaMasivaState.searching || false,
    saving: productosCargaMasivaState.saving || false,
    validationResult: productosCargaMasivaState.validationResult
      ? {
          ...productosCargaMasivaState.validationResult,
          errors: Array.isArray(
            productosCargaMasivaState.validationResult.errors
          )
            ? productosCargaMasivaState.validationResult.errors
            : []
        }
      : null,
    processingResult: productosCargaMasivaState.processingResult || null
  };
};
